import React from "react";
import { Button, TableCell } from "@mui/material";
import { usePhoneMode } from "../../hooks";

export default function FaultIdCell({ universalFaultId, universalConditionId, legacy, onClick }) {
    const { phoneMode } = usePhoneMode();

    let faultIdText = null;
    if (!legacy) {
        faultIdText = `${universalFaultId}-${universalConditionId}`;
    }

    return (
        <TableCell style={{ borderBottom: phoneMode ? 'none' : undefined }}>
            {!legacy ? (
                <Button onClick={onClick} style={{ textWrap: 'nowrap' }}>{faultIdText}</Button>
            ) : null}
        </TableCell>
    );
}